var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartLightLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M24.068 27H7.928C5.98 27 5 26.039 5 24.108V7.892C5 5.961 5.98 5 7.93 5h16.139C26.03 5 27 5.97 27 7.892L27 24.108C27 26.03 26.03 27 24.068 27zM6.502 24.033c0 .97.513 1.465 1.445 1.465H24.05c.923 0 1.445-.494 1.445-1.465v-7.48h-1.844l-1.14 3.554c-.159.532-.989.541-1.147.028l-2.173-6.95-1.222 2.864c-.14.326-.31.504-.692.504h-2.2l-1.129 3.554c-.17.532-1 .541-1.158.028l-2.165-6.95-1.185 2.864c-.128.326-.308.504-.69.504H6.502zm0-8.684V7.967c0-.97.514-1.465 1.445-1.465h16.104c.922 0 1.445.495 1.445 1.465v7.382h-2.182c-.383 0-.58.186-.69.504l-.69 1.95-2.173-6.569c-.17-.503-.926-.503-1.14.029l-1.678 4.086h-2.204c-.373 0-.567.186-.69.504l-.69 1.95-2.173-6.569c-.158-.503-.925-.503-1.14.029l-1.678 4.086z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLightLine);
export default __webpack_public_path__ + "static/media/Chart-Light_Line.9cf3bf996e24c9c41fd6bfe5ba63f500.svg";
export { ForwardRef as ReactComponent };